import { render } from "./Shots.vue?vue&type=template&id=4ba3d569"
import script from "./Shots.vue?vue&type=script&lang=js"
export * from "./Shots.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__